import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

export default function NotFound() {
    return (
        <div className="not-found">
            <div className="not-found__bg">
                <div className="not-found__glow not-found__glow--1" />
                <div className="not-found__glow not-found__glow--2" />
            </div>

            <div className="not-found__content">
                <div className="not-found__code">404</div>
                <h1 className="not-found__title">Sayfa Bulunamadı</h1>
                <p className="not-found__description">
                    Aradığınız sayfa taşınmış, silinmiş veya hiç var olmamış olabilir.
                </p>

                <div className="not-found__actions">
                    <Link to="/" className="not-found__btn not-found__btn--primary">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                            <polyline points="9 22 9 12 15 12 15 22" />
                        </svg>
                        Ana Sayfa
                    </Link>
                    <button
                        onClick={() => window.history.back()}
                        className="not-found__btn not-found__btn--secondary"
                    >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <line x1="19" y1="12" x2="5" y2="12" />
                            <polyline points="12 19 5 12 12 5" />
                        </svg>
                        Geri Dön
                    </button>
                </div>

                <div className="not-found__links">
                    <span>Belki bunları arıyordunuz:</span>
                    <div className="not-found__suggestions">
                        <Link to="/portfolio/">Portfolyo</Link>
                        <Link to="/services/">Hizmetler</Link>
                        <Link to="/store">Mağaza</Link>
                        <Link to="/education/">Eğitim</Link>
                    </div>
                </div>
            </div>

            <div className="not-found__brand">
                <span className="not-found__brand-text">Modelerman</span>
            </div>
        </div>
    );
}
